const mainUrl = PHT_URL;

let BASE_URL;

const getRootDomain = (hostname) => {
  const parts = hostname.split('.');

  return parts.length >= 2 ? parts.slice(-2).join('.') : hostname;
};

const formBaseUrl = (root) => {
  return mainUrl.replace('{host}', root);
};

export const getBaseApiUrl = () => {
  const savedUrl = localStorage.getItem('pht_url');
  if (savedUrl) {
    BASE_URL = savedUrl;
    return BASE_URL;
  }

  if (mainUrl.includes('{host}')) {
    const fullHost = window.location.hostname;
    const root = getRootDomain(fullHost);
    BASE_URL = formBaseUrl(root);
  } else {
    BASE_URL = mainUrl;
  }

  return BASE_URL;
};